import { LinearProgress, Stack, type SxProps, type Theme } from "@mui/material";
import { Card, mergeSxProps, Text } from "@src/appV2/redesign/system/ui-components";

interface LimitedSubStageBannerUIProps {
  score: number;
  thresholdScore: number;
  sx?: SxProps<Theme>;
}

export function LimitedSubStageBannerUI(props: LimitedSubStageBannerUIProps) {
  const { score, thresholdScore, sx: customSx } = props;

  const progressPercentage = Math.min((score / thresholdScore) * 100, 100);
  const unlockLabel = `Unlimited access = ${thresholdScore}pts`;

  return (
    <Card
      sx={mergeSxProps(
        (theme) => ({
          padding: theme.spacing(6),
          background: theme.palette.onboarding?.inProgress.gradient,
          color: theme.palette.text.primary,
        }),
        customSx
      )}
    >
      <Stack spacing={3}>
        <Stack
          direction="row"
          alignItems="baseline"
          spacing={2}
          textAlign="center"
          justifyContent="center"
        >
          <Text variant="h1" sx={{ lineHeight: 1 }}>
            {score}
          </Text>
          <Text variant="h4">pts</Text>
        </Stack>

        <Stack spacing={1}>
          <Text variant="body2" textAlign="right">
            {unlockLabel}
          </Text>
          <LinearProgress
            variant="determinate"
            value={progressPercentage}
            sx={(theme) => ({
              height: 6,
              borderRadius: 999,
              backgroundColor: theme.palette.common.white,
              "& .MuiLinearProgress-bar": {
                backgroundColor: theme.palette.text.primary,
              },
            })}
          />
        </Stack>
      </Stack>
    </Card>
  );
}
